  // Convert PEM public key to CryptoKey
  const importPublicKey = async (pem) => {
    const base64Key = pem.replace(
      /-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\s/g,
      ""
    );

    const binaryString = atob(base64Key);

    const keyBytes = Uint8Array.from(
      binaryString,
      (char) => char.charCodeAt(0)
    );

    return await window.crypto.subtle.importKey(
      "spki",
      keyBytes,
      {
        name: "RSA-OAEP",
        hash: "SHA-256",
      },
      false,
      ["encrypt"]
    );
  };

  // Encrypt password using RSA-OAEP SHA-256
  export const encryptPassword = async (plainPassword) => {
    const publicKey = await importPublicKey(process.env.REACT_APP_PUBLIC_KEY_PEM_PASSWORD);

    const encodedPassword = new TextEncoder().encode(
      plainPassword
    );

    const maxBytes =
      publicKey.algorithm.modulusLength / 8 - 2 * 32 - 2;

    if (encodedPassword.length > maxBytes) {
      throw new Error(
        `Password must be at most ${maxBytes} UTF-8 bytes.`
      );
    }

    const encryptedBuffer = await window.crypto.subtle.encrypt(
      {
        name: "RSA-OAEP",
      },
      publicKey,
      encodedPassword
    );

    // Convert encrypted bytes to Base64
    const encryptedBytes = new Uint8Array(encryptedBuffer);

    const binary = Array.from(
      encryptedBytes,
      (byte) => String.fromCharCode(byte)
    ).join("");

    return btoa(binary);
  };